<template>
    <nav class="sb-topnav navbar navbar-expand navbar-light bg-white" style="box-shadow: 1px 1px 3px #ddd;">
        <router-link class="navbar-brand" :to="{name:'Main'}">
            <img :src="tnkcBanner" class="img-fluid" size="225 x 38.22"/>
        </router-link>

        <button class="btn btn-link btn-sm order-1 order-lg-0" id="sidebarToggle" href="#">
<!--            <i class="fas fa-bars pt-1" style="transform: scaleX(1.5)"></i>-->
            <font-awesome-icon icon="bars" style="transform: scaleX(1.5)"/>
        </button>

        <!-- Navbar Search-->
        <!--        <form class="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-3 my-2 my-md-0">-->
        <!--            <div class="input-group">-->
        <!--                <input class="form-control" type="text" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2" />-->
        <!--                <div class="input-group-append">-->
        <!--                    <button class="btn tnkc-primary" type="button"><i class="fas fa-search"></i></button>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </form>-->
        <!-- Right Nav Link -->
        <ul class="navbar-nav mr-auto">
<!--            <li class="nav-item">-->
<!--                <a class="nav-link" href="#">Right</a>-->
<!--            </li>-->
<!--            <li class="nav-item">-->
<!--                <a class="nav-link" href="#">Link</a>-->
<!--            </li>-->
        </ul>

        <!-- Left Nav Link -->
        <ul class="navbar-nav ml-auto">
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" id="userDropdown" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-user fa-fw"></i>
                    {{titleCase(this.getAuthUserName)}}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
                     <router-link v-if="isSystemAdmin" class="dropdown-item" :to="{name: 'Account'}">Accounts</router-link>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#" @click="logOut">Logout</a>
                </div>
            </li>
        </ul>
    </nav>
</template>

<script>
import TnkcBanner from '../../assets/tnkc-banner.png'
import { alertMixins } from '../../mixins/alertMixins'
import { formMixins } from '../../mixins/formMixins'

import { mapActions, mapGetters } from 'vuex'
import { appMixins } from '../../mixins/app.mixins'

export default {
  name: 'topNav',
  mixins: [alertMixins, formMixins, appMixins],
  data () {
    return {
      tnkcBanner: TnkcBanner
    }
  },

  props: {
    userLog: String
  },

  methods: {
    ...mapActions(['getAuthUserDetails', 'logOutUser']),

    logOut () {
      if (this.logOutUser()) {
        this.$router.push({ name: 'Login' })
      }
    }
  },

  computed: {
    ...mapGetters(['userLogin']),

    getAuthUserName () {
      return `${this.userLogin.last_name}, ${this.userLogin.name} ${ this.userLogin.middle_name ? this.userLogin.middle_name.charAt(0) : ''}.`
    }
  },

  created () {
    this.getAuthUserDetails()
  },

  mounted () {
    // console.log(this.demoAlert);
  }
}
</script>

<style scoped>

</style>
